import { LoaderCircle } from 'lucide-react';
import { SquaredBackground } from '../squared-background';
import { useTranslation } from 'react-i18next';

export const AuthProgressLoader = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className="min-h-screen w-full flex flex-col justify-center items-center pl-2 space-x-2 relative isolate bg-background"
      data-testid="auth-progress-loader"
    >
      <SquaredBackground />

      <div className="w-14 h-14">
        <LoaderCircle className="w-14 h-14 animate-spin" />
      </div>

      {i18n.isInitialized && (
        <>
          <h1 className="pt-6 text-4xl font-bold">
            {t('landing_page.authenticationStillLoadingTitle')}
          </h1>
          <h2 className="pt-2 text-lg text-secondary">
            {t('landing_page.authenticationStillLoadingDescription')}
          </h2>
        </>
      )}
    </div>
  );
};
